import { IClaimNoteReply } from '@/types';
import { AsyncRefWrapper } from '@/classes/asyncRefWrapper';
import { NoteControllerApi } from '@/hooks/api/noteControllerApi';

export class ReplyUpdate extends AsyncRefWrapper<void> {
  public constructor(private _replyId: number) {
    super(undefined);
  }

  public updateReply(reply: IClaimNoteReply): Promise<void> {
    return this.loadFrom(NoteControllerApi.updateReply(this._replyId, reply));
  }
}
